import { reducer as workflowReducer, MOUNT_POINT as WORKFLOW_MOUNT_POINT } from './workflow';
import { reducer as breadcrumbReducer, MOUNT_POINT as BREADCRUMB_MOUNT_POINT } from './breadcrumb';
import { reducer as sidePanelReducer, MOUNT_POINT as SIDE_PANEL_MOUNT_POINT } from './side-panel';
import { reducer as confirmationReducer, MOUNT_POINT as CONFIRMATIONS_MOUNT_POINT } from './confirmations';
import { reducer as networksReducer, MOUNT_POINT as NETWORKS_MOUNT_POINT } from './networks';
import { reducer as callingsReducer, MOUNT_POINT as CALLINGS_MOUNT_POINT } from './callings';
import { reducer as landingTabReducer, MOUNT_POINT as LANDING_TAB_MOUNT_POINT } from './landingTab';
import { reducer as freeTasksReducer, MOUNT_POINT as FREE_TASKS_MOUNT_POINT } from './tasks';
import { reducer as documentTitleReducer, MOUNT_POINT as DOCUMENT_TITLE_MOUNT_POINT } from './documentTitle';

const reducers = {
    [WORKFLOW_MOUNT_POINT]: workflowReducer,
    [BREADCRUMB_MOUNT_POINT]: breadcrumbReducer,
    [SIDE_PANEL_MOUNT_POINT]: sidePanelReducer,
    [CONFIRMATIONS_MOUNT_POINT]: confirmationReducer,
    [NETWORKS_MOUNT_POINT]: networksReducer,
    [CALLINGS_MOUNT_POINT]: callingsReducer,
    [LANDING_TAB_MOUNT_POINT]: landingTabReducer,
    [FREE_TASKS_MOUNT_POINT]: freeTasksReducer,
    [DOCUMENT_TITLE_MOUNT_POINT]: documentTitleReducer,
};

export default reducers;
